import ReactDOM from 'react-dom/client';
import reportWebVitals from "./reportWebVitals";
import Root from "./root";
import "@abgov/web-components";
import { bootstrapDomainKeyRedirect, establishBridgedSession } from "./MPP-Common-SPA/utils/globalUtility";

const renderApplication = () => {
  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
  root.render(<Root />);
  reportWebVitals();
};

bootstrapDomainKeyRedirect()
  .then(async (isRedirecting) => {
    if (isRedirecting) {
      return;
    }

    // On the target program sub-domain, silently bridge the source portal session
    // (if any) before rendering so the app loads already authenticated.
    await establishBridgedSession();
    renderApplication();
  })
  .catch((error) => {
    console.error("Domain key bootstrap redirect failed", error);
    renderApplication();
  });